import {FETCHED_ETH} from '../../types';
import {web3} from '../../../config'

export function getETHBalanceDispatch(){
  return function(dispatch,getState){
    getETHBalance(dispatch,getState())
  }
}

export async function getETHBalance(dispatch,state) {
  let wallet = state.passport.wallet;
  let result = await web3.eth.getBalance(wallet.eth.address)
  dispatch({
    type: FETCHED_ETH,
    payload: web3.utils.fromWei(result)
  });
}
